/**
 * V4.2.T7: drawing-phase timer urgency ramp (pure, render-free).
 *
 * Maps `secondsLeft` against the phase total into one of three urgency
 * "stops" so the timer chip can drive both its color (the --ink/--orange/
 * --urgent ramp) and its non-color cue (icon + text). Kept pure so the
 * threshold math is unit-testable without rendering.
 *
 * Fraction-of-time-remaining stops (per spec note 5d):
 *   fraction > 0.50            -> "calm"      (--ink)
 *   0.25 <= fraction <= 0.50   -> "warning"   (--orange)
 *   fraction < 0.25            -> "critical"  (--urgent) + pulse
 *
 * Edge handling: a non-positive `totalSeconds` (missing/garbage settings)
 * can't yield a meaningful fraction, treat as "calm" rather than divide by
 * zero. `secondsLeft === 0` lands in "critical" (fraction 0 < 0.25), which is
 * the spec's "HOLD on critical at zero" state, the CSS, not this helper,
 * stops the pulse at zero.
 */
export type TimerStop = "calm" | "warning" | "critical";

export function timerStop(secondsLeft: number, totalSeconds: number): TimerStop {
  if (totalSeconds <= 0) return "calm";
  const fraction = secondsLeft / totalSeconds;
  if (fraction > 0.5) return "calm";
  if (fraction >= 0.25) return "warning";
  return "critical";
}
